/* import __COLOCATED_TEMPLATE__ from './request-wrapper.hbs'; */
import { classNameBindings, classNames } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './request-wrapper.module.scss';

@classic
@classNames('d-flex', 'flex-wrap', styles.component)
@classNameBindings('fullScreen:full-screen:', 'currentStepClass', 'prescreenerClass')
export default class RequestRequestWrapper extends Component {
  @service prescreener;
  @computed('activeSteps.@each.isActive')
  get currentStep() {
    return this.activeSteps.findBy('isActive');
  }

  @computed('currentStep.route')
  get currentStepClass() {
    if (!this.currentStep) {
      // eslint-disable-next-line getter-return
      return;
    }

    return `${this.currentStep.route}-step`;
  }

  @computed('activeSteps.[]', 'currentStep')
  get previousStep() {
    if (this.get('currentStep.previousStepDisabled')) {
      return null;
    }
    let currentIndex = this.activeSteps.indexOf(this.currentStep);
    return this.activeSteps.objectAt(currentIndex - 1);
  }

  @computed('prescreener.isPrescreenerEnabled')
  get prescreenerClass() {
    return this.prescreener.isPrescreenerEnabled ? 'use-prescreener' : null;
  }
}
